module.exports = __webpack_public_path__ + "static/images/components/BuildingCardImage/images/arrow/arrow-4-100.ff70031d.png";


//////////////////
// WEBPACK FOOTER
// ./components/BuildingCardImage/images/arrow/arrow-4-100.png
// module id = 2559
// module chunks = 11